import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MondoFormControl } from 'app/core/mondo-form-builder';
import { PostFormService } from 'app/forum/services/post-form.service';
import {
  DateOptions,
  PickerMode,
} from 'app/shared/components/date-picker/date-picker.component';

@Component({
  selector: 'app-scheduling-dialog',
  template: `
    <h2>{{ 'Schedule' | preventHardcoding }}</h2>
    <div mat-dialog-content>
      {{ 'SchedulePostText' | preventHardcoding }}
    </div>
    <div style="display:flex; justify-content:center; margin:1em 0;">
      <div>
        <app-date-picker
          [dateOptions]="schedulingDateOptions"
          [fControl]="tempControl"
        ></app-date-picker>
      </div>
    </div>
    <div
      style="display: flex; justify-content: center; margin-bottom: 1em; gap: 1em"
    >
      <button
        mat-raised-button
        mat-dialog-close
        color="primary"
        matTooltipPosition="above"
        [matTooltip]="'Back' | preventHardcoding"
        (click)="cancel()"
      >
        {{ 'Back' | preventHardcoding }}
      </button>

      <button
        mat-raised-button
        mat-dialog-close
        color="primary"
        matTooltipPosition="above"
        [matTooltip]="'Next' | preventHardcoding"
        (click)="save()"
      >
        {{ 'Next' | preventHardcoding }}
      </button>
    </div>
  `,
  styleUrls: ['./scheduling-dialog.component.scss'],
})
export class SchedulingDialogComponent implements OnInit {
  tempControl = new MondoFormControl<Date>(null);

  readonly schedulingDateOptions: DateOptions = {
    startDate: new Date(),
    pickerMode: PickerMode.day,
    disabled: false,
    placeholder: 'DatePlaceholderLabel',
    timePickerLabel: 'timePickerLabel',
    optionalHint: '',
    startView: 'multi-year',
    showClearBtn: true,
  };

  constructor(
    private postFormService: PostFormService,
    private dialogRef: MatDialogRef<SchedulingDialogComponent>
  ) {}

  ngOnInit() {
    const plannedAt = this.postFormService.getForm().value.plannedAt;
    if (plannedAt) {
      this.tempControl.setValue(new Date(plannedAt));
    } else {
      this.tempControl.setValue(null);
    }

    this.dialogRef.keydownEvents().subscribe((event) => {
      if (event.code === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        this.cancel();
      }
    });
  }

  save() {
    const val = this.tempControl.value;
    this.dialogRef.close(val ? val.getTime() : null);
  }

  cancel() {
    const val = this.tempControl.value;
    this.dialogRef.close(val ? val.getTime() : null);
  }
}
